import { useEffect, useState } from "react"
import { useSelector, shallowEqual } from "react-redux";
import { Dispatch } from "redux";
import { getTerminals } from "../../../store/futureSecurity/actions";


export const useLoadMetrics = (dispatch: Dispatch<any>) => {
  const { locations, terminals } = useSelector(
    (state: MainState) => ({
      locations: state.authentication.futureSecurityTenants,
      username: state.authentication.username,
      terminals: state.futureSecurity.terminals
    }),
    shallowEqual
  );

  const [location, setLocation] = useState(locations[0]);

  useEffect(() => {
    setLocation(locations[0]);
  }, [locations]);

  useEffect(() => {
    dispatch(getTerminals(location))
  }, [location])



  return { location, setLocation }
}